import http from "../../util/axios";

export default {
  //获取oss凭证
  getStsToken() {
    return http.get("/app/oss/getStsToken");
  },
};



// WEBPACK FOOTER //
// ./src/api/ossApis/index.js